import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2c8a3151&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8a3151')) {
      api.createRecord('2c8a3151', component.options)
    } else {
      api.reload('2c8a3151', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=2c8a3151&", function () {
      api.rerender('2c8a3151', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/header.vue"
export default component.exports